import { authorizedApiClient } from "../config";
import type { McpStatusResponse, McpStatusScope } from "./mcp.types";

export const getMcpStatus = ({
  workspace_id,
  scope = "me",
}: {
  workspace_id: string;
  scope?: McpStatusScope;
}) =>
  authorizedApiClient.get<McpStatusResponse>(`/workspace/${workspace_id}/mcp/status`, {
    params: { scope },
  });
